export default __webpack_public_path__ + "assets/models/9b942be8cd266b81143ac7d693eb550e.glb";